import { defineStore } from "pinia";
import { login, getUserInfo, getPermissionList, logout } from "@/services";
import localCache from "@/utils/cache";

/**
 * 重命名权限对象列表
 * @param {Object} permissionObj 权限对象
 * @returns
 */
const renamePermissionList = (permissionObj) => {
  const permissionList = {};
  const permissionNameMap = new Map();
  permissionNameMap.set("PC-角色管理", "roleManagement");
  permissionNameMap.set("PC-角色管理:查询", "roleSelect");
  permissionNameMap.set("PC-角色管理:编辑", "roleEdit");
  permissionNameMap.set("PC-角色管理:删除", "roleDelete");
  permissionNameMap.set("PC-角色管理:新增", "roleAdd");
  permissionNameMap.set("PC-用户管理", "accountManagement");
  permissionNameMap.set("PC-用户管理:查询", "accountSelect");
  permissionNameMap.set("PC-用户管理:编辑", "accountEdit");
  permissionNameMap.set("PC-用户管理:删除", "accountDelete");
  permissionNameMap.set("PC-用户管理:新增", "accountAdd");

  for (const key in permissionObj) {
    const element = permissionObj[key];
    const renameKey = permissionNameMap.get(key);
    permissionList[renameKey] = element.map((item) => {
      item.name = permissionNameMap.get(item.name);
      return item;
    });
  }
  return permissionList;
};

const useLoginStore = defineStore("login", {
  state: () => ({
    token: "",
    userInfo: null, // 当前登录的用户信息
    permissionList: {}, // 权限列表
  }),
  actions: {
    /**
     * 用户登录
     * @param {Object} payload
     * @param {String} payload.username
     * @param {String} payload.password
     * @param {String} payload.verfiyCode
     */
    async accountLogin(payload) {
      const { username, password, verifyCode } = payload;
      let loginResult = "";
      try {
        loginResult = await login(username, password, verifyCode);
      } catch (error) {
        // console.log("loginResult error:", error);
      }
      // console.log("loginResult", loginResult);
      if (loginResult.code === 200) {
        const token = loginResult.data
        // localCache.setCache('token', token)
        sessionStorage.setItem('token', token)
        this.changeToken(token)

      }
      return loginResult;
    },

    /**
     * 改变token
     * @param {String} token token
     */
    changeToken(token) {
      this.token = token;
    },

    /**
     * 获取当前登录的用户信息
     */
    async fetchUserInfo() {
      const userInfoResult = await getUserInfo();
      // console.log("userInfoResult", userInfoResult);
      if (userInfoResult?.code === 200) {
        this.userInfo = userInfoResult.data;
        // localCache.setCache('userInfo', this.userInfo)
        sessionStorage.setItem('userInfo',JSON.stringify(this.userInfo))
      }
    },

    /**
     * 获取权限列表
     */
    async fetchPermissionList() {
      const permissionListResult = await getPermissionList();
      // console.log("permissionListResult", permissionListResult);
      if (permissionListResult?.code === 200) {
        const permissionObj = permissionListResult.data["飞行汽车管理权限"];
        this.permissionList = renamePermissionList(permissionObj);
      }
    },
    async logout() {
      let res = await logout();
      return res
    }
    
  },
});

export default useLoginStore;
